export type NewsCategory = "新闻" | "花絮" | "独家采访";

export interface NewsParagraph {
  type: "text" | "quote" | "image";
  content: string;
  caption?: string;
}

export interface NewsItem {
  id: string;
  title: string;
  category: NewsCategory;
  publishedAt: string;
  summary: string;
  thumbnail: string;
  cover: string;
  tags: string[];
  relatedTitleIds: string[];
  paragraphs: NewsParagraph[];
  views: number;
}

const newsList: NewsItem[] = [
  {
    id: "n-01",
    title: "《长夜观测站》大结局收视破纪录，制作方确认电影版补拍计划",
    category: "新闻",
    publishedAt: "2026-10-16",
    summary:
      "剧集《长夜观测站》以 12 集完结收官，最后一集播出当晚站内热度刷新平台纪录。总制片人透露，电影《长夜将尽》将补拍一段与剧集呼应的镜头。",
    thumbnail: "https://readdy.ai/api/search-image?query=Press%20event%20photo%20of%20a%20film%20production%20crew%20in%20front%20of%20a%20large%20antenna%20array%20on%20a%20snowy%20island%20set%2C%20deep%20navy%20and%20amber%20lighting%2C%20cinematic%20documentary%20photography%2C%20high%20detail&width=600&height=400&seq=news-observatory-1&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20snowy%20island%20research%20station%20set%20at%20night%20with%20crew%20lights%2C%20deep%20navy%20sky%20and%20warm%20amber%20production%20lights%2C%20atmospheric%20behind%20the%20scenes%20photography%2C%20high%20detail&width=1600&height=900&seq=news-observatory-cover&orientation=landscape",
    tags: ["长夜观测站", "剧集", "收视"],
    relatedTitleIds: ["t-01", "m-01"],
    views: 128400,
    paragraphs: [
      {
        type: "text",
        content:
          "10 月 15 日晚，《长夜观测站》迎来完结。据平台公布的数据，大结局上线 24 小时内热度值突破历史峰值，弹幕总量超过 680 万条，成为今年讨论度最高的剧集之一。",
      },
      {
        type: "text",
        content:
          "导演沈砚舟在随后的线上见面会上表示，剧集的十二集对应了极夜的第一年，而电影《长夜将尽》讲述的则是第八年发生的事。“两条时间线互为镜像，观众看完剧集再回看电影，会发现很多之前没注意的细节。”",
      },
      {
        type: "quote",
        content: "“我们不是在拍一部关于宇宙的剧，而是在拍一群在黑暗里仍然愿意抬头的人。”—— 导演 沈砚舟",
      },
      {
        type: "image",
        content: "https://readdy.ai/api/search-image?query=Cinematic%20film%20set%20photo%20of%20a%20glass%20observatory%20control%20room%20with%20many%20monitors%20and%20an%20actor%20in%20a%20navy%20jacket%2C%20deep%20navy%20and%20amber%20lighting%2C%20behind%20the%20scenes%20photography%2C%20high%20detail&width=1600&height=900&seq=news-observatory-inline&orientation=landscape",
        caption: "剧集美术团队搭建的观测站控制室，全实景搭景超过 1400 平方米。",
      },
      {
        type: "text",
        content:
          "据制片方透露，电影版将在年底进行为期两周的补拍，其中一段与新剧集结尾直接呼应的镜头会加入最终版本。具体上映档期将在完成后期后公布。",
      },
    ],
  },
  {
    id: "n-02",
    title: "独家采访｜江晚照：在极夜里演一个“不肯闭眼”的人",
    category: "独家采访",
    publishedAt: "2026-10-14",
    summary:
      "从《长夜将尽》到《长夜观测站》，江晚照用一个角色走过了八年时间。她聊了聊极端环境下的表演方法，以及那场被影迷反复讨论的九分钟无声戏。",
    thumbnail: "https://readdy.ai/api/search-image?query=Editorial%20portrait%20photo%20of%20a%20calm%20young%20Chinese%20actress%20in%20a%20dark%20navy%20knit%20sweater%20sitting%20in%20a%20minimal%20studio%2C%20soft%20key%20light%20on%20a%20deep%20slate%20background%2C%20subtle%20teal%20rim%20light%2C%20magazine%20interview%20photography%2C%20high%20detail&width=600&height=400&seq=news-jiangwanzhao-1&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20wide%20portrait%20photo%20of%20a%20calm%20young%20Chinese%20actress%20in%20a%20dark%20navy%20coat%20standing%20in%20a%20minimal%20grey%20studio%2C%20soft%20key%20light%20with%20teal%20rim%2C%20magazine%20interview%20photography%2C%20high%20detail&width=1600&height=900&seq=news-jiangwanzhao-cover&orientation=landscape",
    tags: ["江晚照", "独家采访", "表演"],
    relatedTitleIds: ["m-01", "t-01"],
    views: 96500,
    paragraphs: [
      {
        type: "text",
        content:
          "采访约在下午三点，江晚照刚结束一场配音工作。她说自己最近的生活很简单：早上看剧本，下午去录音棚，晚上回家陪猫。这样的节奏，和拍的戏形成了鲜明反差。",
      },
      {
        type: "text",
        content:
          "“拍极夜的那段时间，我几乎不看手机。”她回忆，为了维持角色的状态，剧组要求所有人在片场减少交流。“不是刻意冷落谁，而是想让沉默变成一种真实的习惯。人一旦习惯了不说话，眼睛就开始说话。”",
      },
      {
        type: "image",
        content: "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20young%20Chinese%20actress%20looking%20out%20a%20panoramic%20window%20at%20falling%20snow%2C%20deep%20navy%20tones%20with%20soft%20amber%20light%20on%20her%20face%2C%20quiet%20emotion%2C%20high%20detail&width=1600&height=900&seq=news-jiangwanzhao-inline&orientation=landscape",
        caption: "电影《长夜将尽》中，被影迷称为“年度最佳”的九分钟无声段落。",
      },
      {
        type: "text",
        content:
          "聊到那场九分钟的无声戏，她说拍了两天，中间只休息了四十分钟。“导演只给我一句话：不要演崩溃，演忍住。后来观众说看哭了，其实我们拍的时候都没哭。”",
      },
      {
        type: "quote",
        content: "“我不想演一个英雄，我想演一个在黑暗里仍然选择抬起头的人。”",
      },
    ],
  },
  {
    id: "n-03",
    title: "《星尘列车》发布首支正片片段：一节车厢，一整片银河",
    category: "花絮",
    publishedAt: "2026-10-11",
    summary:
      "片方放出长达两分四十秒的正片片段，展示列车穿过小行星带时的车内视角。美术团队同步公开了车厢设计手稿与虚拟制片流程。",
    thumbnail: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20photo%20of%20a%20retro%20futuristic%20train%20carriage%20set%20with%20a%20huge%20LED%20volume%20screen%2C%20deep%20navy%20and%20amber%20lighting%2C%20film%20production%20photography%2C%20high%20detail&width=600&height=400&seq=news-stardust-1&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20film%20set%20with%20a%20retro%20futuristic%20train%20carriage%20inside%20a%20large%20LED%20volume%20stage%2C%20deep%20navy%20and%20amber%20lighting%2C%20sci%20fi%20production%20design%2C%20high%20detail&width=1600&height=900&seq=news-stardust-cover&orientation=landscape",
    tags: ["星尘列车", "幕后", "虚拟制片"],
    relatedTitleIds: ["m-04", "t-04"],
    views: 74200,
    paragraphs: [
      {
        type: "text",
        content:
          "《星尘列车》今日发布首支正片片段，镜头跟随列车长 Iris 走过最后一节车厢，窗外是一整片缓慢旋转的星云。片段没有一句对白，却完整呈现了影片的视觉基调。",
      },
      {
        type: "image",
        content: "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20retro%20futuristic%20train%20carriage%20window%20showing%20a%20rotating%20nebula%20in%20deep%20navy%20and%20amber%20tones%2C%20elegant%20interior%20details%2C%20high%20detail&width=1600&height=900&seq=news-stardust-inline&orientation=landscape",
        caption: "片段中的星云画面为实时渲染，配合车厢灯光变化同步调色。",
      },
      {
        type: "text",
        content:
          "美术指导介绍，整列车由十二节车厢组成，每节车厢对应一种视觉主题：玻璃穹顶、藏书室、温室花园、旧式餐车等。所有车厢都在同一个 LED 环形棚内搭建，通过实时渲染让窗外星体随车速移动。",
      },
      {
        type: "quote",
        content: "“我们想让观众相信，这列车真的在宇宙里开了很多年。”—— 美术指导 Elena Miro",
      },
    ],
  },
  {
    id: "n-04",
    title: "《雾城疑云》官宣第二季启动，原班人马回归雾都",
    category: "新闻",
    publishedAt: "2026-10-09",
    summary:
      "出品方正式确认《雾城疑云》第二季已进入剧本阶段，故事将从第一季大结局留下的那枚钥匙展开，预计明年春季开机。",
    thumbnail: "https://readdy.ai/api/search-image?query=Press%20photo%20of%20a%20foggy%20old%20city%20street%20with%20a%20single%20streetlamp%20and%20a%20small%20production%20sign%2C%20deep%20teal%20grey%20tones%20with%20warm%20amber%20light%2C%20high%20detail&width=600&height=400&seq=news-mistcity-1&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20foggy%20old%20city%20street%20at%20night%20with%20warm%20streetlamps%20glowing%20through%20mist%2C%20deep%20teal%20grey%20tones%2C%20mystery%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=news-mistcity-cover&orientation=landscape",
    tags: ["雾城疑云", "续订", "悬疑"],
    relatedTitleIds: ["t-02", "t-07"],
    views: 81300,
    paragraphs: [
      {
        type: "text",
        content:
          "在《雾城疑云》收官半年后，出品方今日正式宣布第二季启动。制片人表示，第二季仍将坚持“全剧雾天”的视觉设定，但会把故事从城市推向海边的旧码头。",
      },
      {
        type: "text",
        content:
          "第一季大结局中，法医宋一在证物袋里留下一枚生锈的铜钥匙，这枚钥匙将成为第二季的起点。编剧团队透露，新一季会加入一条与八年前旧案平行的时间线。",
      },
      {
        type: "quote",
        content: "“第一季我们问的是谁在撒谎，第二季我们想问，为什么所有人都愿意一起撒谎。”—— 编剧 孟昭",
      },
      {
        type: "image",
        content: "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20rusty%20brass%20key%20in%20a%20clear%20evidence%20bag%20on%20a%20metal%20table%2C%20cold%20teal%20light%20with%20warm%20amber%20highlight%2C%20mystery%20detail%20shot%2C%20high%20detail&width=1600&height=900&seq=news-mistcity-inline&orientation=landscape",
        caption: "第一季大结局中的铜钥匙，将成为第二季的核心线索。",
      },
    ],
  },
  {
    id: "n-05",
    title: "《潮汐之上》特别放映现场：散场后观众久久没有离开",
    category: "花絮",
    publishedAt: "2026-10-06",
    summary:
      "星光传媒主办的“潮汐特别放映”在沿海小城举行，导演徐望与主演赵岑到场。放映结束后，主创和观众一起在退潮的海滩上走了一段路。",
    thumbnail: "https://readdy.ai/api/search-image?query=Documentary%20photo%20of%20a%20seaside%20open%20air%20screening%20with%20a%20small%20audience%20on%20a%20tidal%20flat%20at%20dusk%2C%20cool%20slate%20blue%20and%20warm%20amber%20tones%2C%20high%20detail&width=600&height=400&seq=news-tide-1&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20seaside%20open%20air%20screening%20on%20a%20tidal%20flat%20at%20dusk%20with%20a%20small%20audience%20on%20low%20stools%2C%20cool%20slate%20blue%20sky%20and%20warm%20amber%20screen%20glow%2C%20high%20detail&width=1600&height=900&seq=news-tide-cover&orientation=landscape",
    tags: ["潮汐之上", "特别放映", "线下活动"],
    relatedTitleIds: ["m-08", "t-08"],
    views: 45800,
    paragraphs: [
      {
        type: "text",
        content:
          "这场放映安排在退潮后的沙滩上，银幕正对着一条搁浅多年的旧木船——那正是电影中父亲修了半辈子的那条船。观众坐在低矮的木凳上，海风把银幕边缘吹得微微起伏。",
      },
      {
        type: "image",
        content: "https://readdy.ai/api/search-image?query=Documentary%20photo%20of%20an%20old%20wooden%20boat%20on%20a%20tidal%20flat%20at%20dusk%20with%20soft%20amber%20lantern%20light%2C%20cool%20slate%20blue%20tones%2C%20quiet%20nostalgic%20mood%2C%20high%20detail&width=1600&height=900&seq=news-tide-inline&orientation=landscape",
        caption: "电影中出现的旧木船，如今停放在小城的潮间带上。",
      },
      {
        type: "text",
        content:
          "映后交流中，导演徐望说：“我们拍这部电影的时候，一直担心观众会觉得太安静。今天坐在这里，我听见了海的声音，反而觉得安静是对的。”",
      },
      {
        type: "quote",
        content: "“散场的时候没有人急着走，这比任何评分都重要。”—— 导演 徐望",
      },
    ],
  },
  {
    id: "n-06",
    title: "独家采访｜杜望川：动作片不是打得更狠，而是更疼",
    category: "独家采访",
    publishedAt: "2026-10-02",
    summary:
      "从《第七码头》到《沉默证词》，杜望川一直在拍“会疼”的电影。他谈了自己对动作场面的理解，以及为什么新片几乎没有配乐。",
    thumbnail: "https://readdy.ai/api/search-image?query=Editorial%20portrait%20photo%20of%20a%20chinese%20film%20director%20in%20his%20fifties%20wearing%20a%20dark%20shirt%20in%20a%20minimal%20studio%2C%20hard%20directional%20light%20on%20a%20deep%20charcoal%20background%2C%20subtle%20teal%20rim%2C%20magazine%20interview%20photography%2C%20high%20detail&width=600&height=400&seq=news-duwangchuan-1&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20wide%20portrait%20photo%20of%20a%20chinese%20film%20director%20sitting%20in%20a%20dim%20editing%20room%20with%20warm%20amber%20monitor%20glow%2C%20deep%20charcoal%20tones%2C%20magazine%20interview%20photography%2C%20high%20detail&width=1600&height=900&seq=news-duwangchuan-cover&orientation=landscape",
    tags: ["杜望川", "独家采访", "动作设计"],
    relatedTitleIds: ["m-03", "m-10"],
    views: 52900,
    paragraphs: [
      {
        type: "text",
        content:
          "杜望川的办公室里有一块白板，上面贴着《沉默证词》的庭审时间线。他说自己习惯把每场戏都当成一次交叉问询，“观众要有机会自己判断，而不是被我牵着走”。",
      },
      {
        type: "text",
        content:
          "谈到《第七码头》那段十九分钟的码头追逐，他解释了自己的原则：“我不喜欢为了好看而打架，我希望每一次动手都有代价。观众看完之后会觉得手臂发酸，那才算拍对了。”",
      },
      {
        type: "quote",
        content: "“动作片不是打得更狠，而是更疼。”",
      },
      {
        type: "image",
        content: "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20two%20men%20in%20a%20standoff%20on%20a%20rainy%20container%20pier%20with%20teal%20and%20amber%20neon%20reflections%2C%20gritty%20action%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=news-duwangchuan-inline&orientation=landscape",
        caption: "《第七码头》中长达十九分钟的码头追逐戏，全片采用实拍完成。",
      },
    ],
  },
  {
    id: "n-07",
    title: "《海雾之下》发布幕后特辑：水下摄影怎么拍出“雾”",
    category: "花絮",
    publishedAt: "2026-09-28",
    summary:
      "特辑揭秘剧集的水下摄影方案：剧组在近海搭建水下轨道，并通过悬浮微粒与定向光源，制造出“水下也有雾”的独特质感。",
    thumbnail: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20photo%20of%20an%20underwater%20camera%20rig%20and%20crew%20diver%20in%20murky%20deep%20slate%20blue%20water%20with%20faint%20warm%20light%20rays%2C%20documentary%20photography%2C%20high%20detail&width=600&height=400&seq=news-seafog-1&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20underwater%20shot%20of%20a%20camera%20rig%20suspended%20in%20murky%20deep%20slate%20blue%20water%20with%20faint%20warm%20light%20rays%2C%20documentary%20photography%2C%20high%20detail&width=1600&height=900&seq=news-seafog-cover&orientation=landscape",
    tags: ["海雾之下", "幕后", "摄影"],
    relatedTitleIds: ["t-07", "t-02"],
    views: 61200,
    paragraphs: [
      {
        type: "text",
        content:
          "《海雾之下》今日发布一支 6 分钟幕后特辑，重点揭秘第三集那场水下搜救戏。摄影指导介绍，为了在水下还原“雾”的层次，剧组在安全区域投放了可降解的悬浮微粒，并配合定向顶光形成散射。",
      },
      {
        type: "image",
        content: "https://readdy.ai/api/search-image?query=Cinematic%20underwater%20film%20still%20of%20a%20diver%20silhouette%20in%20foggy%20deep%20blue%20water%20with%20warm%20amber%20light%20rays%20from%20above%2C%20mysterious%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=news-seafog-inline&orientation=landscape",
        caption: "水下场景的散射效果由悬浮微粒与定向光源共同完成。",
      },
      {
        type: "text",
        content:
          "演员顾清和透露，这场戏连续拍摄了十一天，每天只能在水中待四十分钟。“上岸之后整个人都是晕的，但看到监视器里的画面，会觉得值。”",
      },
    ],
  },
  {
    id: "n-08",
    title: "星光传媒公布 2027 年度片单：十二部新作，六部为原创",
    category: "新闻",
    publishedAt: "2026-09-22",
    summary:
      "星光传媒年度发布会在上海举行，公布 2027 年片单，涵盖电影、剧集与纪录片三条线，其中六部为完全原创故事。",
    thumbnail: "https://readdy.ai/api/search-image?query=Press%20conference%20photo%20of%20a%20large%20dark%20stage%20with%20a%20minimal%20warm%20amber%20logo%20light%20and%20a%20row%20of%20seated%20journalists%2C%20deep%20navy%20tones%2C%20corporate%20event%20photography%2C%20high%20detail&width=600&height=400&seq=news-slate-1&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20dark%20press%20conference%20stage%20with%20a%20minimal%20warm%20amber%20light%20panel%20and%20empty%20director%20chairs%2C%20deep%20navy%20tones%2C%20corporate%20event%20photography%2C%20high%20detail&width=1600&height=900&seq=news-slate-cover&orientation=landscape",
    tags: ["星光传媒", "片单", "发布会"],
    relatedTitleIds: ["t-01", "m-04", "m-10"],
    views: 104600,
    paragraphs: [
      {
        type: "text",
        content:
          "星光传媒年度内容发布会在上海举行，现场公布了 2027 年度片单。十二部新作中，电影五部、剧集六部、纪录片一部，其中六部为完全原创故事。",
      },
      {
        type: "text",
        content:
          "发布会同时宣布成立“新光计划”，未来三年将支持十二位新导演完成首部长片，并开放部分拍摄基地资源给青年创作者使用。",
      },
      {
        type: "quote",
        content: "“我们想做的不是更多，而是更值得被记住。”—— 星光传媒内容负责人",
      },
      {
        type: "image",
        content: "https://readdy.ai/api/search-image?query=Corporate%20event%20photo%20of%20a%20dark%20showcase%20wall%20with%20minimal%20cinematic%20poster%20frames%20and%20warm%20amber%20accent%20light%2C%20deep%20navy%20tones%2C%20high%20detail&width=1600&height=900&seq=news-slate-inline&orientation=landscape",
        caption: "发布会现场陈列的 2027 年度片单视觉墙。",
      },
    ],
  },
  {
    id: "n-09",
    title: "《山河食记》第二季开拍，剧组沿着一条河走了两个月",
    category: "花絮",
    publishedAt: "2026-09-15",
    summary:
      "剧组透露第二季将沿着另一条南方水系逆流而上，走访十四个村落，全部采用自然光与同期声拍摄。",
    thumbnail: "https://readdy.ai/api/search-image?query=Documentary%20photo%20of%20a%20small%20film%20crew%20with%20cameras%20on%20a%20wooden%20boat%20on%20a%20misty%20river%20in%20early%20morning%2C%20soft%20cream%20and%20warm%20amber%20tones%2C%20high%20detail&width=600&height=400&seq=news-river-1&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20wooden%20boat%20with%20a%20small%20film%20crew%20on%20a%20misty%20river%20at%20dawn%2C%20soft%20cream%20and%20warm%20amber%20tones%2C%20documentary%20photography%2C%20high%20detail&width=1600&height=900&seq=news-river-cover&orientation=landscape",
    tags: ["山河食记", "开拍", "纪录剧"],
    relatedTitleIds: ["t-03", "m-07"],
    views: 38700,
    paragraphs: [
      {
        type: "text",
        content:
          "《山河食记》第二季正式开拍。剧组没有使用大型设备，六个人、两条船，沿着另一条南方水系逆流而上，计划走访十四个村落。",
      },
      {
        type: "image",
        content: "https://readdy.ai/api/search-image?query=Documentary%20photo%20of%20a%20village%20kitchen%20with%20steaming%20bamboo%20baskets%20and%20an%20elderly%20woman%20cooking%2C%20soft%20warm%20daylight%2C%20cream%20and%20amber%20tones%2C%20high%20detail&width=1600&height=900&seq=news-river-inline&orientation=landscape",
        caption: "第二季首站拍摄地，村民正在准备当天的家常菜。",
      },
      {
        type: "text",
        content:
          "导演罗青禾说，第二季会减少解说，把更多时间留给现场的声音：“锅里的水声、切菜的节奏、老人说话的语气，这些比任何旁白都好。”",
      },
    ],
  },
  {
    id: "n-10",
    title: "《午夜食堂·终章》终极预告上线：最后一碗汤的配方",
    category: "新闻",
    publishedAt: "2026-09-08",
    summary:
      "系列收官电影发布终极预告，长达两分半的预告里没有一句台词，只有切菜、煮汤与碗筷相碰的声音。",
    thumbnail: "https://readdy.ai/api/search-image?query=Warm%20cinematic%20still%20of%20a%20steaming%20bowl%20of%20soup%20on%20a%20wooden%20counter%20with%20amber%20lantern%20light%2C%20deep%20brown%20tones%2C%20intimate%20mood%2C%20high%20detail&width=600&height=400&seq=news-diner-1&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=Warm%20cinematic%20wide%20shot%20of%20a%20tiny%20midnight%20diner%20counter%20with%20several%20steaming%20bowls%20and%20amber%20lantern%20light%20through%20the%20window%2C%20deep%20brown%20tones%2C%20high%20detail&width=1600&height=900&seq=news-diner-cover&orientation=landscape",
    tags: ["午夜食堂", "预告", "收官"],
    relatedTitleIds: ["m-07", "m-05"],
    views: 69300,
    paragraphs: [
      {
        type: "text",
        content:
          "《午夜食堂·终章》今日发布终极预告。全片预告以厨房里的声音为主：刀落案板、汤沸、碗筷相碰。直到最后两秒，才出现老板的那句“欢迎回来”。",
      },
      {
        type: "quote",
        content: "“最后一碗汤不需要配方，需要的是有人愿意坐下来喝完。”",
      },
      {
        type: "image",
        content: "https://readdy.ai/api/search-image?query=Warm%20cinematic%20film%20still%20of%20a%20chef%20hands%20placing%20a%20steaming%20bowl%20on%20a%20wooden%20counter%20with%20amber%20lantern%20light%2C%20deep%20brown%20tones%2C%20high%20detail&width=1600&height=900&seq=news-diner-inline&orientation=landscape",
        caption: "预告中最后一个镜头，老板把最后一碗汤放在了老位置。",
      },
    ],
  },
  {
    id: "n-11",
    title: "专题｜为什么这两年，观众重新爱上了“慢”",
    category: "独家采访",
    publishedAt: "2026-09-01",
    summary:
      "从《潮汐之上》到《山河食记》，一批节奏缓慢的作品获得了超出预期的关注。我们和三位主创聊了聊观众口味的变化。",
    thumbnail: "https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20an%20empty%20cinema%20seat%20row%20with%20soft%20warm%20projector%20light%20haze%2C%20deep%20brown%20and%20amber%20tones%2C%20cinematic%20mood%2C%20high%20detail&width=600&height=400&seq=news-slow-1&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20an%20empty%20cinema%20auditorium%20with%20warm%20projector%20light%20haze%20and%20rows%20of%20seats%2C%20deep%20brown%20and%20amber%20tones%2C%20contemplative%20mood%2C%20high%20detail&width=1600&height=900&seq=news-slow-cover&orientation=landscape",
    tags: ["行业观察", "慢节奏", "专题"],
    relatedTitleIds: ["m-08", "t-03", "m-05"],
    views: 55400,
    paragraphs: [
      {
        type: "text",
        content:
          "过去一年，几部节奏明显偏慢的作品在口碑与播放量上都取得了意外的好成绩。它们没有密集的情节反转，也没有强烈的剪辑节奏，却让观众愿意坐下来，看完两个小时。",
      },
      {
        type: "text",
        content:
          "《潮汐之上》导演徐望认为，这和观众的生活状态有关：“大家每天已经被信息推着跑了，进电影院反而想慢一点。慢不是拖沓，是把注意力还给观众。”",
      },
      {
        type: "quote",
        content: "“观众不是没有耐心，是很少有作品值得他们耐心。”—— 导演 罗青禾",
      },
      {
        type: "image",
        content: "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20quiet%20riverside%20house%20at%20sunset%20with%20warm%20amber%20light%20and%20long%20shadows%2C%20soft%20cream%20tones%2C%20contemplative%20mood%2C%20high%20detail&width=1600&height=900&seq=news-slow-inline&orientation=landscape",
        caption: "慢节奏作品往往把大量篇幅交给环境与静默。",
      },
    ],
  },
  {
    id: "n-12",
    title: "《王座与灰烬》服装特辑公开：一件披风要缝 90 天",
    category: "花絮",
    publishedAt: "2026-08-26",
    summary:
      "剧集服装组公开了北境之主的披风制作过程，从手工织造到做旧处理，共耗时三个月，动用了十二位绣工。",
    thumbnail: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20photo%20of%20a%20costume%20workshop%20with%20heavy%20textured%20cloaks%20and%20amber%20work%20lamps%2C%20deep%20charcoal%20and%20ochre%20tones%2C%20documentary%20photography%2C%20high%20detail&width=600&height=400&seq=news-throne-1&orientation=landscape",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20costume%20workshop%20with%20heavy%20embroidered%20fantasy%20cloaks%20on%20mannequins%20and%20warm%20amber%20work%20lamps%2C%20deep%20charcoal%20and%20ochre%20tones%2C%20high%20detail&width=1600&height=900&seq=news-throne-cover&orientation=landscape",
    tags: ["王座与灰烬", "服装", "幕后"],
    relatedTitleIds: ["t-06", "t-04"],
    views: 41200,
    paragraphs: [
      {
        type: "text",
        content:
          "《王座与灰烬》今日发布服装特辑。北境之主的披风由十二位绣工手工完成，从织造到做旧共耗时九十天，使用了超过两公斤的羊毛与亚麻混纺面料。",
      },
      {
        type: "image",
        content: "https://readdy.ai/api/search-image?query=Detail%20photo%20of%20heavy%20embroidered%20wool%20fabric%20with%20ochre%20thread%20and%20weathered%20texture%20under%20warm%20amber%20light%2C%20high%20detail&width=1600&height=900&seq=news-throne-inline&orientation=landscape",
        caption: "披风边缘的手工刺绣，每一处破损都由服装组人工做旧。",
      },
      {
        type: "text",
        content:
          "服装指导表示，剧中每一件重甲都需要两名工作人员才能为演员穿上，最长的一次换装耗时四十分钟。",
      },
    ],
  },
];

export const newsItems = newsList;

export const newsCategories: Array<NewsCategory | "全部"> = ["全部", "新闻", "花絮", "独家采访"];

export function getNewsById(id: string | undefined): NewsItem | undefined {
  return newsList.find((item) => item.id === id);
}

export function getRelatedNews(current: NewsItem, limit = 3): NewsItem[] {
  return newsList
    .filter((item) => item.id !== current.id)
    .map((item) => {
      let score = item.tags.filter((tag) => current.tags.includes(tag)).length * 2;
      score += item.relatedTitleIds.filter((id) => current.relatedTitleIds.includes(id)).length * 2;
      if (item.category === current.category) score += 1;
      return { item, score };
    })
    .sort((a, b) => b.score - a.score)
    .slice(0, limit)
    .map((entry) => entry.item);
}

export const newsHighlights = ["n-01", "n-02", "n-03", "n-08"];

export function getNewsHighlights(): NewsItem[] {
  return newsHighlights
    .map((id) => getNewsById(id))
    .filter((item): item is NewsItem => Boolean(item));
}

export function getNewsByTitleId(titleId: string): NewsItem[] {
  return newsList.filter((item) => item.relatedTitleIds.includes(titleId));
}